import { Box, Button, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import EditIcon from "@mui/icons-material/Edit";
import ChangeOwnerProfileDetailsModal from "../../modals/ChangeOwnerProfileDetailsModal";
import PropertyAddressFetchModal from "../../modals/PropertyAddressFetchModal";
import React, { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { hasNOC } from "../../permitForms/permitFormHelpers";
import { isPropertyDatabaseCounty } from "../../../functions/availablePermitForms";
// import MapModal from "../../propertyMap/MapModal";

const OwnerTab = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const { selectedRow, selectedPermitType } = useSelector(
    (state) => state.myPermitsComponent,
  );

  const property_owner = selectedRow?.property_owner;
  const isEmptyObject = (obj) => {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [propertyFetchModalOpen, setPropertyFetchModalOpen] = useState(false);
  const [fieldValues, setFieldValues] = useState({
    ownerEmail: property_owner?.email || "",
    ownerMobile: property_owner?.mobile || "",
    ownerEmailError: false,
    ownerMobileError: false,
  });
  const [fieldChangedText, setFieldChangedText] = useState("");
  const [loading, setLoading] = useState(false);

  // Check if we should show property fetch option
  const isRealEstateCounty = isPropertyDatabaseCounty(selectedRow?.county);
  const hasNoNOC = !hasNOC(selectedRow, selectedPermitType);
  const hasNoProjectAddress = !selectedRow?.project_address;
  const shouldShowPropertyFetch =
    isRealEstateCounty && hasNoNOC && hasNoProjectAddress;

  const handleChangeOwnerDetails = async () => {
    try {
      setLoading(true);
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/building/update-owner-profile-info`,
        {
          task_id: selectedRow?.task_id,
          newEmail: fieldValues?.ownerEmail,
          newMobile: fieldValues?.ownerMobile,
          currentSession: currentSession,
        },
        { withCredentials: true },
      );
      if (resp?.data?.success) {
        setFieldChangedText(resp?.data?.message);
        setTimeout(() => {
          setModalOpen(false);
          setFieldValues({
            ownerEmail: fieldValues?.ownerEmail,
            ownerMobile: fieldValues?.ownerMobile,
            ownerEmailError: false,
            ownerMobileError: false,
          });
          setLoading(false);
          setFieldChangedText("");
        }, 3000);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          pt: 1,
          boxSizing: "border-box",
          flex: 1,
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          minHeight: 0,
        }}
      >
        <img
          src="/img/website_img/house.png"
          alt="house"
          style={{
            width: "100%",
            maxWidth: "5rem",
            height: "auto",
            borderRadius: "20px",
          }}
        />
        {!property_owner || isEmptyObject(property_owner) ? (
          <Box mt={6} px={2}>
            {shouldShowPropertyFetch ? (
              <>
                <Typography align="center" px={1} variant="h6" color="primary">
                  Fetch Property Details
                </Typography>
                <Typography
                  align="center"
                  px={1}
                  variant="body2"
                  color="text.secondary"
                  mt={2}
                  mb={3}
                >
                  Would you like to fetch property owner details from the{" "}
                  {selectedRow?.county} County Property Appraiser database to
                  auto-populate your forms?
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setPropertyFetchModalOpen(true)}
                  >
                    Fetch Property Details
                  </Button>
                </Box>
              </>
            ) : (
              <Typography align="center" px={1} variant="h6" color="primary">
                To display property owner information, please create a Notice of
                Commencement first
              </Typography>
            )}
          </Box>
        ) : (
          <>
            <Typography mt={1} fontWeight="bold">
              {property_owner?.name}
            </Typography>
            {selectedRow?.notarized ||
            selectedRow?.processing_permit?.notarization?.owner?.notarization
              ?.waiting_to_schedule ? (
              <></>
            ) : (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={() => setModalOpen(true)}
                  startIcon={<EditIcon />}
                >
                  Edit Details
                </Button>
              </Box>
            )}

            {/* <MapModal address="16081 Tisons Bluff Road, Jacksonville, FL 32218" /> */}
            {/* <Box mt={6}> */}
            <Box mt={3}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mb: 0.5,
                }}
              >
                <LocationOnIcon />
                <Typography>
                  {property_owner?.address_parts?.address ||
                    property_owner?.address_parts?.address1}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mb: 0.5,
                }}
              >
                <LocationOnIcon />
                <Typography>
                  {property_owner?.address_parts?.city}{" "}
                  {property_owner?.address_parts?.state}{" "}
                  {property_owner?.address_parts?.zipCode ||
                    property_owner?.address_parts?.zip_code}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mb: 0.5,
                }}
              >
                <EmailIcon />
                <Typography>{property_owner?.email || "Unknown"}</Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mb: 0.5,
                }}
              >
                <PhoneIcon />
                <Typography>{property_owner?.mobile || "Unknown"}</Typography>
              </Box>
            </Box>
          </>
        )}
      </Box>
      <ChangeOwnerProfileDetailsModal
        open={modalOpen}
        setOpen={setModalOpen}
        onConfirm={handleChangeOwnerDetails}
        fieldValues={fieldValues}
        setFieldValues={setFieldValues}
        fieldChangedText={fieldChangedText}
        loading={loading}
        property_owner={property_owner}
      />
      <PropertyAddressFetchModal
        open={propertyFetchModalOpen}
        onClose={() => setPropertyFetchModalOpen(false)}
        onSuccess={(data) => {
          // Property data has been saved and will update automatically
        }}
      />
    </>
  );
};

export default React.memo(OwnerTab);
